<div class="query-row query-filter-row">
  <dcc-billboard
    label="Releases"
    [value]="total | number"></dcc-billboard>

  <dcc-release-name-input
    class="query-input"
    [urlValue]="this.query.releaseName"
    (wordTyped)="onReleaseNameEntered($event)"></dcc-release-name-input>

  <ng-select
    bindLabel="name"
    bindValue="name"
    class="ng-select-width"
    placeholder="Status"
    [items]="statusOptions"
    [multiple]="true"
    [(ngModel)]="statusOptionsSelected"
    (change)="onStatusSelectionChange($event)">
    <ng-template
      let-item="item"
      ng-option-tmp>
      <input
        type="checkbox"
        [checked]="item.selected" />
      {{ item.name }}
    </ng-template>
  </ng-select>

  <ng-select
    bindLabel="name"
    bindValue="name"
    class="ng-select-width"
    placeholder="App Type"
    [items]="appTypeOptions"
    [multiple]="true"
    [(ngModel)]="appTypeSelected"
    (change)="onAppSelectionChange($event)">
    <ng-template
      let-item="item"
      ng-option-tmp>
      <input
        type="checkbox"
        [checked]="item.selected" />
      {{ item.name }}
    </ng-template>
  </ng-select>

  <dcc-release-owner-input
    class="query-input"
    [urlValue]="this.query.releaseCreator"
    (wordTyped)="onReleaseOwnerEntered($event)"></dcc-release-owner-input>

  <dcc-reset-button (reset)="onReset()"></dcc-reset-button>
</div>
